const version ='1.7.1'
export default version
console.log(version)
